import './index.less';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/locale-provider/style/index.js
// module id = 1766
// module chunks = 0